// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1InvoiceRuleSchema } from './v1/invoiceRuleSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const showInvoiceRulesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const showInvoiceRulesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Invoice rules retrieved
 */
export const showInvoiceRules200Schema = z.lazy(() => v1InvoiceRuleSchema);

/**
 * @description Unauthorized
 */
export const showInvoiceRules401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const showInvoiceRulesQueryResponseSchema = z.lazy(() => showInvoiceRules200Schema);
